import styled from 'foundations-theming/utils';
import { trellisBreakpoint } from 'pricing-pages-ui-components/constants/Breakpoints';
import { BREEZE_INTELLIGENCE_STARTER_PLATFORM_CARD } from '../../constants/tracking/TrackingSources';
import BreezeIntelligenceStarterPlatformBanner from './BreezeIntelligenceStarterPlatformBanner';
import BreezeIntelligenceStarterPlatformCard from './BreezeIntelligenceStarterPlatformCard';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const StyledFlex = styled.div.withConfig({
  displayName: "BreezeIntelligenceStarterPlatform__StyledFlex",
  componentId: "sc-1l1tjv-0"
})(({
  theme
}) => {
  return {
    display: 'flex',
    justifyContent: 'space-between',
    gap: theme.space[800],
    [trellisBreakpoint.tablet]: {
      flexDirection: 'column'
    }
  };
});
const BreezeIntelligenceStarterPlatform = ({
  screen
}) => {
  const trackingSource = BREEZE_INTELLIGENCE_STARTER_PLATFORM_CARD;
  return /*#__PURE__*/_jsxs(StyledFlex, {
    children: [/*#__PURE__*/_jsx(BreezeIntelligenceStarterPlatformBanner, {
      trackingSource: trackingSource
    }), /*#__PURE__*/_jsx(BreezeIntelligenceStarterPlatformCard, {
      screen: screen,
      trackingSource: trackingSource
    })]
  });
};
export default BreezeIntelligenceStarterPlatform;